module.exports = __webpack_public_path__ + "static/img/zywb.b4a01d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jianjie/zywb.png
// module id = AS/Z
// module chunks = 171